/*
  aBeauty - telefon obligatoriu la orice comandă, cu prefix de țară (2026-07-31)

  De ce în temă și nu în checkout: magazinul e pe plan Shopify (non-Plus), deci
  checkout-ul nu poate fi extins. Setarea „Shipping address phone number:
  Required" e activă, dar se aplică doar comenzilor cu livrare. Serviciile,
  examinările și abonamentul PRIVE au requiresShipping: false, deci checkout-ul
  le arată doar adresa de facturare, unde telefonul e OPTIONAL și nu poate fi
  făcut obligatoriu pe planurile non-Plus.

  De ce prefix de țară: avem clienți stabiliți în alte țări. Fără țara aleasă
  explicit, un „0712345678" tastat de un francez ar deveni tăcut un număr
  românesc, iar un „069123456" moldovenesc ar fi respins ca invalid. În plus,
  aplicația terță care primește abonamentele PRIVE identifică clientul după
  numărul național, deci îl salvăm separat de forma internațională.

  Ce trimite la comandă:
    Telefon            E.164, ex. +40712345678
    _Telefon_Tara      ISO2, ex. RO
    _Telefon_National  numărul național fără prefix, ex. 712345678

  Comportament:
  - blochează formularul de produs și pe cel de coș dacă numărul nu e valid
    pentru țara aleasă (fail-open: dacă scriptul nu se încarcă, comanda trece,
    ca să nu pierdem vânzări);
  - ține ascunse butoanele de plată rapidă (Shop Pay, Google Pay) până când
    numărul e valid, fiindcă ele sar peste coș și peste validarea noastră
    (fail-closed: sunt ascunse din markup, se arată din JS);
  - validează cu libphonenumber, încărcată la prima atingere a câmpului, deci
    nu intră în calea de randare a paginii;
  - salvează numărul și ca atribut de coș, ca să apară o singură dată pe comandă,
    la „Additional details".
*/

(function () {
  'use strict';

  if (window.__abeautyTelefon) return;
  window.__abeautyTelefon = true;

  var TEXT_EROARE = 'Introdu un număr de telefon valid pentru țara aleasă.';

  /* Majoritatea țărilor scot zeroul de trunchi din numărul național. Italia nu:
     acolo 06 1234567 rămâne 061234567 și în forma internațională. Lista contează
     doar pentru validarea de rezervă, cea din bibliotecă știe toate excepțiile. */
  var TARI_CU_ZERO_IN_NATIONAL = { IT: 1 };

  var TARI_FRECVENTE = ['RO', 'MD'];

  var biblioteca = null;
  var incarcare = null;
  var eticheta = document.querySelector('script[data-abeauty-tel-lib]');
  var URL_BIBLIOTECA = eticheta ? eticheta.getAttribute('data-abeauty-tel-lib') : null;

  function prefixe() {
    return window.ABEAUTY_TEL_PREFIXE || {};
  }

  /* ---------------------------------------------------------------- bibliotecă */

  function incarcaBiblioteca() {
    if (biblioteca || incarcare) return;
    if (!URL_BIBLIOTECA || !window.Promise) return;
    incarcare = true;
    var s = document.createElement('script');
    s.src = URL_BIBLIOTECA;
    s.async = true;
    s.onload = function () {
      biblioteca = window.libphonenumber || null;
      refreshAll();
    };
    s.onerror = function () {
      /* rămâne validarea de rezervă, mai permisivă */
    };
    document.head.appendChild(s);
  }

  /* ------------------------------------------------------------------ analiză */

  function taraDupaPrefix(digits, taraPreferata) {
    var map = prefixe();
    if (taraPreferata && map[taraPreferata] && digits.indexOf(map[taraPreferata]) === 0) {
      return taraPreferata;
    }
    var gasit = null;
    var lungime = 0;
    for (var iso in map) {
      var p = map[iso];
      if (digits.indexOf(p) === 0 && p.length > lungime) {
        gasit = iso;
        lungime = p.length;
      }
    }
    return gasit;
  }

  /* Validare de rezervă, folosită doar dacă biblioteca nu s-a încărcat. */
  function analizaDeRezerva(text, iso) {
    var map = prefixe();
    var prefix = map[iso];
    if (!prefix) return null;

    var v = (text || '').replace(/[^0-9+]/g, '');
    if (!v) return null;
    if (v.indexOf('00') === 0) v = '+' + v.slice(2);

    if (v.charAt(0) === '+') {
      if (!/^\+[1-9]\d{7,14}$/.test(v)) return null;
      var isoGasit = taraDupaPrefix(v.slice(1), iso) || iso;
      var prefixGasit = map[isoGasit] || prefix;
      return { e164: v, national: v.slice(1 + prefixGasit.length), iso: isoGasit };
    }

    var national = v;
    if (!TARI_CU_ZERO_IN_NATIONAL[iso]) national = national.replace(/^0/, '');
    if (iso === 'RO' && !/^[23789]\d{8}$/.test(national)) return null;
    if (!/^\d{4,14}$/.test(national)) return null;
    return { e164: '+' + prefix + national, national: national, iso: iso };
  }

  function analizeaza(text, iso) {
    if (!text || !String(text).trim()) return null;
    if (biblioteca) {
      var p = null;
      try {
        p = biblioteca.parsePhoneNumberFromString(String(text), iso);
      } catch (e) {
        p = null;
      }
      if (!p || !p.isValid()) return null;
      var afisat = '';
      try {
        afisat = p.formatNational();
      } catch (e) {
        afisat = '';
      }
      return {
        e164: p.number,
        national: String(p.nationalNumber),
        iso: p.country || iso,
        afisat: afisat,
      };
    }
    return analizaDeRezerva(text, iso);
  }

  /* Formatare live, doar când cursorul e la capăt și utilizatorul nu șterge. */
  function formateazaLive(input, iso, tipModificare) {
    if (!biblioteca) return;
    if (tipModificare && tipModificare.indexOf('delete') === 0) return;
    if (input.value.indexOf('+') === 0) return;
    var laCapat = true;
    try {
      laCapat = input.selectionStart === input.value.length;
    } catch (e) {
      /* inputurile de tip tel nu expun selection în toate browserele */
    }
    if (!laCapat) return;
    try {
      var formatat = new biblioteca.AsYouType(iso).input(input.value);
      if (formatat && formatat !== input.value) input.value = formatat;
    } catch (e) {
      /* formatarea e cosmetică, nu blocăm nimic dacă pică */
    }
  }

  /* ----------------------------------------------------------------- selector */

  function numeTari() {
    var afisare = null;
    try {
      afisare = new Intl.DisplayNames(['ro'], { type: 'region' });
    } catch (e) {
      afisare = null;
    }
    var map = prefixe();
    var lista = [];
    for (var iso in map) {
      var nume = iso;
      if (afisare) {
        try {
          nume = afisare.of(iso) || iso;
        } catch (e) {
          nume = iso;
        }
      }
      lista.push({ iso: iso, prefix: map[iso], nume: nume });
    }
    lista.sort(function (a, b) {
      return a.nume.localeCompare(b.nume, 'ro');
    });
    return lista;
  }

  function construiesteSelector(select) {
    if (!select || select.dataset.abeautyGata === '1') return;
    var map = prefixe();
    if (!map || !map.RO) return;
    select.dataset.abeautyGata = '1';

    var selectat = select.value || 'RO';
    var lista = numeTari();
    var fragment = document.createDocumentFragment();

    var adauga = function (tara, parinte) {
      var opt = document.createElement('option');
      opt.value = tara.iso;
      opt.textContent = tara.nume + ' (+' + tara.prefix + ')';
      if (tara.iso === selectat) opt.selected = true;
      parinte.appendChild(opt);
    };

    var grupFrecvente = document.createElement('optgroup');
    grupFrecvente.label = 'Frecvente';
    var frecvente = {};
    for (var i = 0; i < TARI_FRECVENTE.length; i++) {
      var iso = TARI_FRECVENTE[i];
      for (var j = 0; j < lista.length; j++) {
        if (lista[j].iso === iso) {
          adauga(lista[j], grupFrecvente);
          frecvente[iso] = 1;
          break;
        }
      }
    }
    fragment.appendChild(grupFrecvente);

    var grupToate = document.createElement('optgroup');
    grupToate.label = 'Toate țările';
    for (var k = 0; k < lista.length; k++) {
      if (!frecvente[lista[k].iso]) adauga(lista[k], grupToate);
    }
    fragment.appendChild(grupToate);

    while (select.firstChild) select.removeChild(select.firstChild);
    select.appendChild(fragment);
    select.value = selectat;
  }

  /* ------------------------------------------------------- câmpuri ascunse */

  function initCamp(wrap) {
    if (wrap.dataset.abeautyGata === '1') return;
    wrap.dataset.abeautyGata = '1';

    var input = wrap.querySelector('[data-abeauty-tel-input]');
    if (!input) return;
    var formular = input.getAttribute('form');

    /* Fără JS, inputul vizibil poartă `name` și trimite ce a tastat clientul.
       Cu JS, trimitem cele trei valori structurate din câmpuri ascunse. */
    input.removeAttribute('name');

    var creeaza = function (nume, valoare) {
      if (!nume) return null;
      var h = document.createElement('input');
      h.type = 'hidden';
      h.name = nume;
      h.value = valoare || '';
      if (formular) h.setAttribute('form', formular);
      wrap.appendChild(h);
      return h;
    };

    wrap.abeautyE164 = creeaza(wrap.dataset.telName, wrap.dataset.telE164);
    wrap.abeautyTara = creeaza(wrap.dataset.telNameTara, wrap.dataset.telTara);
    wrap.abeautyNational = creeaza(wrap.dataset.telNameNational, '');

    construiesteSelector(wrap.querySelector('[data-abeauty-tel-country]'));
  }

  function scrieAscunse(wrap, rezultat) {
    if (wrap.abeautyE164) wrap.abeautyE164.value = rezultat ? rezultat.e164 : '';
    if (wrap.abeautyTara) wrap.abeautyTara.value = rezultat ? rezultat.iso : '';
    if (wrap.abeautyNational) wrap.abeautyNational.value = rezultat ? rezultat.national : '';
  }

  /* ------------------------------------------------------------------- stare */

  function scopeOf(el) {
    return el.closest('[data-abeauty-tel-scope]') || document;
  }

  function wrapIn(scope) {
    return scope.querySelector('[data-abeauty-tel]');
  }

  function refresh(scope, arataEroare) {
    var wrap = wrapIn(scope);
    if (!wrap) return true;
    initCamp(wrap);

    var input = wrap.querySelector('[data-abeauty-tel-input]');
    var select = wrap.querySelector('[data-abeauty-tel-country]');
    if (!input) return true;

    var iso = (select && select.value) || wrap.dataset.telTara || 'RO';
    var rezultat = analizeaza(input.value, iso);

    /* Numărul lipit în format internațional poate veni din altă țară decât cea
       aleasă. Doar atunci mutăm selectorul și lăsăm în câmp partea națională.
       La un număr scris în format național NU mutăm selectorul, chiar dacă
       biblioteca vede o țară mai precisă: un mobil britanic din seria 7911 e de
       fapt din Guernsey, iar saltul de la „Regatul Unit" la „Guernsey" sub
       degetele clientului arată a bug. Câmpul ascuns păstrează oricum țara
       exactă întoarsă de bibliotecă, iar E.164 și numărul național sunt aceleași. */
    var internationalScris = input.value.indexOf('+') === 0 || input.value.indexOf('00') === 0;
    if (internationalScris && rezultat) {
      if (rezultat.iso && rezultat.iso !== iso && select && select.querySelector('option[value="' + rezultat.iso + '"]')) {
        select.value = rezultat.iso;
        iso = rezultat.iso;
      }
      /* Trecem câmpul pe forma națională și când țara nu s-a schimbat, altfel ar
         rămâne afișat „00 40 712 345 678" pentru un număr românesc. Forma
         națională a bibliotecii păstrează și zeroul de trunchi, deci clientul
         român își vede numărul cum îl știe: 0712 345 678. */
      input.value = rezultat.afisat || rezultat.national;
      if (!rezultat.afisat) formateazaLive(input, iso, null);
    }

    /* Valoarea precompletată din coș vine ca număr național brut (712345678).
       După ce se încarcă biblioteca o rescriem în forma cu care e obișnuit
       clientul (0712 345 678), dar numai cât timp nu a pus el mâna pe câmp. */
    if (!wrap.abeautyAtins && rezultat && rezultat.afisat && input.value !== rezultat.afisat) {
      input.value = rezultat.afisat;
    }

    var valid = !!rezultat;
    scrieAscunse(wrap, rezultat);

    var eroare = wrap.querySelector('[data-abeauty-tel-error]');
    input.setCustomValidity(valid ? '' : TEXT_EROARE);
    wrap.classList.toggle('abeauty-tel--invalid', !valid && arataEroare === true);
    if (eroare) eroare.hidden = valid || arataEroare !== true;

    Array.prototype.forEach.call(scope.querySelectorAll('[data-abeauty-tel-gate]'), function (el) {
      el.hidden = !valid;
    });
    Array.prototype.forEach.call(scope.querySelectorAll('[data-abeauty-tel-gate-note]'), function (el) {
      el.hidden = valid;
    });
    Array.prototype.forEach.call(scope.querySelectorAll('[data-abeauty-tel-block-note]'), function (el) {
      el.hidden = valid;
    });

    return valid;
  }

  function salveazaInCos(rezultat) {
    var url = (window.routes && window.routes.cart_update_url) || '/cart/update.js';
    try {
      fetch(url, {
        method: 'POST',
        /* keepalive: cererea supraviețuiește navigării spre checkout (trimiterea din fereastra de coș) */
        keepalive: true,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: {
            Telefon: rezultat.e164,
            Telefon_Tara: rezultat.iso,
            Telefon_National: rezultat.national,
          },
        }),
      }).catch(function () {});
    } catch (e) {
      /* dacă nu se salvează ca atribut, rămâne cel din line item property */
    }
  }

  /* Fereastra „produs adăugat în coș" se randează o singură dată, la încărcarea
     paginii, deci butonul ei de checkout nu știe de telefonul completat acum.
     Îl deblocăm din JS, după ce un formular a trecut de validare. */
  /* formTrimis: formularul care se trimite acum. Câmpurile lui NU se dezactivează: browserul
     construiește datele formularului DUPĂ evenimentul submit, iar un câmp dezactivat nu se trimite
     (auditul 19.10: telefonul din fereastra de coș ajungea doar prin fetch-ul paralel). */
  function marcheazaTelefonCunoscut(formTrimis) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-abeauty-tel-checkout]'), function (el) {
      el.hidden = false;
    });
    /* Câmpul din fereastra „produs adăugat" nu mai e necesar: îl ascundem și îl
       dezactivăm, ca să nu blocheze trimiterea și să nu trimită atribute goale
       peste numărul tocmai salvat. */
    Array.prototype.forEach.call(document.querySelectorAll('[data-abeauty-tel-notif]'), function (el) {
      if (el.contains(document.activeElement) || (formTrimis && formTrimis.contains(el))) return;
      el.dataset.abCunoscut = '1';
      el.hidden = true;
      Array.prototype.forEach.call(el.querySelectorAll('input, select'), function (camp) {
        camp.disabled = true;
      });
    });
  }

  function refreshAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-abeauty-tel]'), function (wrap) {
      /* păstrează un mesaj de eroare deja afișat (porneste() rulează și la redesenări de secțiuni) */
      refresh(scopeOf(wrap), wrap.classList.contains('abeauty-tel--invalid'));
    });
  }

  /* ------------------------------------------------------------------ evenimente */

  document.addEventListener(
    'focusin',
    function (event) {
      if (event.target.closest && event.target.closest('[data-abeauty-tel]')) incarcaBiblioteca();
    },
    true
  );

  document.addEventListener('input', function (event) {
    var input = event.target.closest ? event.target.closest('[data-abeauty-tel-input]') : null;
    if (!input) return;
    incarcaBiblioteca();
    var wrap = input.closest('[data-abeauty-tel]');
    if (wrap) wrap.abeautyAtins = true;
    var select = wrap && wrap.querySelector('[data-abeauty-tel-country]');
    formateazaLive(input, (select && select.value) || 'RO', event.inputType);
    refresh(scopeOf(input), false);
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest ? event.target.closest('[data-abeauty-tel-country]') : null;
    if (!select) return;
    var wrap = select.closest('[data-abeauty-tel]');
    var input = wrap && wrap.querySelector('[data-abeauty-tel-input]');
    if (input) input.placeholder = select.value === 'RO' ? '0712 345 678' : '';
    refresh(scopeOf(select), true);
  });

  document.addEventListener(
    'blur',
    function (event) {
      var input = event.target.closest ? event.target.closest('[data-abeauty-tel-input]') : null;
      if (!input) return;
      var scope = scopeOf(input);
      /* Un mesaj de eroare deja afișat (după o încercare de trimitere) rămâne până la un număr valid;
         altfel ieșirea din câmpul gol îl ascundea imediat (auditul 19.10). */
      var wrapBlur = input.closest('[data-abeauty-tel]');
      var dejaInvalid = !!(wrapBlur && wrapBlur.classList.contains('abeauty-tel--invalid'));
      var valid = refresh(scope, input.value.trim() !== '' || dejaInvalid);
      if (valid) {
        var wrap = wrapIn(scope);
        salveazaInCos({
          e164: wrap.abeautyE164.value,
          iso: wrap.abeautyTara.value,
          national: wrap.abeautyNational.value,
        });
      }
    },
    true
  );

  /* Validarea nativă (setCustomValidity) oprește trimiterea ÎNAINTE de evenimentul submit, deci
     mesajul nostru nu apărea niciodată: îl afișăm din evenimentul `invalid` (auditul 19.10). */
  document.addEventListener(
    'invalid',
    function (event) {
      var input = event.target && event.target.closest ? event.target.closest('[data-abeauty-tel-input]') : null;
      if (!input) return;
      event.preventDefault();
      refresh(scopeOf(input), true);
      input.focus();
      if (input.scrollIntoView) input.scrollIntoView({ block: 'center', behavior: 'smooth' });
    },
    true
  );

  /* Capture pe document: rulează înaintea handlerelor Dawn de pe formular. */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.querySelector) return;
      var wrap = form.querySelector('[data-abeauty-tel]');
      if (!wrap) {
        /* butonul de checkout din coș e legat de formular prin form="cart" */
        if (form.id !== 'cart') return;
        /* Fereastra „produs adăugat" are și ea un scope, randat în header,
           deci înaintea coșului în DOM: căutăm întâi scope-ul din pagina de coș. */
        var scopeCos =
          document.querySelector('#main-cart-footer [data-abeauty-tel-scope]') ||
          document.querySelector('[data-abeauty-tel-scope]');
        if (!scopeCos) return;
        wrap = wrapIn(scopeCos);
        if (!wrap) return;
      }
      /* Câmp ascuns din fereastra „produs adăugat": telefonul e deja în coș. */
      if (wrap.closest('[data-abeauty-tel-notif][hidden]')) return;
      var scope = scopeOf(wrap);
      if (refresh(scope, true)) {
        salveazaInCos({
          e164: wrap.abeautyE164.value,
          iso: wrap.abeautyTara.value,
          national: wrap.abeautyNational.value,
        });
        marcheazaTelefonCunoscut(form);
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      var input = wrap.querySelector('[data-abeauty-tel-input]');
      if (input) {
        input.focus();
        if (input.scrollIntoView) input.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    },
    true
  );

  function porneste() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-abeauty-tel]'), function (wrap) {
      initCamp(wrap);
    });
    /* Câmpul din fereastra de coș randat ascuns (coș doar cu produse livrate): dezactivat, ca să nu
       blocheze trimiterea; potrivesteNotificarea îl reactivează dacă apare un serviciu în coș. */
    Array.prototype.forEach.call(document.querySelectorAll('[data-ab-dezactivat-initial]'), function (el) {
      el.removeAttribute('data-ab-dezactivat-initial');
      Array.prototype.forEach.call(el.querySelectorAll('input, select'), function (camp) {
        camp.disabled = true;
      });
    });
    refreshAll();
    /* Dacă vine cu telefon precompletat din coș, avem nevoie de bibliotecă mai
       devreme, ca revalidarea să nu cadă pe regulile de rezervă. */
    var precompletat = document.querySelector('[data-abeauty-tel][data-tel-e164]:not([data-tel-e164=""])');
    if (precompletat) incarcaBiblioteca();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', porneste);
  } else {
    porneste();
  }

  /* 2026-10-19: în fereastra „produs adăugat", câmpul de telefon apare doar dacă în coș e cel
     puțin un serviciu (articol fără livrare). La un coș doar cu produse livrate, telefonul îl
     cere checkout-ul la adresa de livrare. Starea coșului vine din /cart.js după fiecare adăugare. */
  function potrivesteNotificarea() {
    var campuri = document.querySelectorAll('[data-abeauty-tel-notif]');
    if (!campuri.length || !window.fetch) return;
    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
      headers: { Accept: 'application/json' },
    })
      .then(function (r) { return r.json(); })
      .then(function (cos) {
        var items = (cos && cos.items) || [];
        var areServicii = items.some(function (i) { return !i.requires_shipping; });
        var stiut = (cos && cos.attributes && cos.attributes.Telefon) ||
          items.some(function (i) { return i.properties && i.properties.Telefon; });
        var ascunde = !areServicii || !!stiut;
        Array.prototype.forEach.call(campuri, function (el) {
          if (el.contains(document.activeElement) || el.dataset.abCunoscut === '1') return;
          el.hidden = ascunde;
          Array.prototype.forEach.call(el.querySelectorAll('input, select'), function (camp) {
            camp.disabled = ascunde;
          });
        });
      })
      .catch(function () {});
  }
  /* 2026-10-19: pe pagina de coș, Dawn redesenează după o schimbare doar subtotalul. Recitim secțiunea
     și înlocuim subsolul coșului doar dacă s-a schimbat semnătura (servicii | livrare | valoarea
     produselor livrate), adică exact ce decide telefonul, plata rapidă și nota de prag. */
  function reimprospateazaSubsolCos() {
    var sectiune = document.getElementById('main-cart-footer');
    var curent = sectiune && sectiune.querySelector('[data-ab-cos-sig]');
    if (!curent || !window.fetch || !window.DOMParser) return;
    fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectiune.dataset.id))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var nou = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ab-cos-sig]');
        if (!nou || nou.getAttribute('data-ab-cos-sig') === curent.getAttribute('data-ab-cos-sig')) return;
        if (curent.contains(document.activeElement)) return;
        curent.replaceWith(document.importNode(nou, true));
      })
      .catch(function () {});
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, potrivesteNotificarea);
    subscribe(PUB_SUB_EVENTS.cartUpdate, reimprospateazaSubsolCos);
  }

  /* Coșul, notificarea de coș și modalul quick add se redesenează din secțiuni. */
  if (window.MutationObserver) {
    var observator = new MutationObserver(function (mutatii) {
      for (var i = 0; i < mutatii.length; i++) {
        for (var j = 0; j < mutatii[i].addedNodes.length; j++) {
          var nod = mutatii[i].addedNodes[j];
          if (nod.nodeType !== 1) continue;
          if (nod.matches('[data-abeauty-tel]') || nod.querySelector('[data-abeauty-tel]')) {
            porneste();
            return;
          }
        }
      }
    });
    observator.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
